import React, { useState } from 'react';
import './Team.css';

interface TeamMember {
  id: number;
  name: string;
  position: string;
  description: string;
  image: string;
}

const TeamMemberCard: React.FC<{ member: TeamMember }> = ({ member }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="team-member-card">
      <div className="team-member-image">
        {!imageError ? (
          <img 
            src={member.image} 
            alt={member.name}
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="image-placeholder">
            {member.name.charAt(0)}
          </div>
        )}
      </div>
      <div className="team-member-info">
        <h3 className="team-member-name">{member.name}</h3>
        <p className="team-member-position">{member.position}</p>
        <p className="team-member-description">{member.description}</p>
      </div>
    </div>
  );
};

const Team: React.FC = () => {
  // Placeholder team data - replace with actual team members and image paths
  const teamMembers: TeamMember[] = [
        {
      id: 3,
      name: 'Team Member 3',
      position: 'Chief Financial Officer',
      description: 'Managing financial operations and ensuring sustainable growth.',
      image: 'https://res.cloudinary.com/dwxjd1gko/image/upload/v1767992479/ms.jpg' // Replace with actual image path
    },
    {
      id: 1,
      name: 'Team Member 1',
      position: 'Chief Executive Officer',
      description: 'Leading the company with vision and expertise in healthcare management.',
      image: 'https://res.cloudinary.com/dwxjd1gko/image/upload/v1767562236/zaeem_c6iw4u.jpg' // Replace with actual image path
    },
    {
      id: 2,
      name: 'Team Member 2',
      position: 'Chief Technology Officer',
      description: 'Driving innovation and technological excellence in healthcare solutions.',
      image: 'https://res.cloudinary.com/dwxjd1gko/image/upload/v1767562253/ahmar_h6c5b1.jpg' // Replace with actual image path
    },
    {
      id: 4,
      name: 'Team Member 4',
      position: 'Operations Director',
      description: 'Overseeing day-to-day operations and ensuring quality service delivery.',
      image: '/api/placeholder/300/400' // Replace with actual image path
    },
    {
      id: 5,
      name: 'Team Member 5',
      position: 'Healthcare Consultant',
      description: 'Providing expert guidance on healthcare revenue cycle management.',
      image: '/api/placeholder/300/400' // Replace with actual image path
    },
    {
      id: 6,
      name: 'Team Member 6',
      position: 'Quality Assurance Manager',
      description: 'Ensuring compliance and maintaining the highest quality standards.',
      image: '/api/placeholder/300/400' // Replace with actual image path
    },
    {
      id: 7,
      name: 'Team Member 7',
      position: 'Client Relations Manager',
      description: 'Building strong relationships with clients and partners.',
      image: '/api/placeholder/300/400' // Replace with actual image path
    },
    {
      id: 8,
      name: 'Team Member 8',
      position: 'Billing Specialist',
      description: 'Expert in medical billing and coding with years of experience.',
      image: '/api/placeholder/300/400' // Replace with actual image path
    }
  ];

  return (
    <div className="team">
      {/* Hero Section */}
      <section className="team-hero">
        <div className="container">
          <h1>Our Team</h1>
          <p>Meet the experts behind Nexus Solutions</p>
        </div>
      </section>

      {/* Description Section */}
      <section className="team-description">
        <div className="container">
          <div className="description-content">
            <p>
              At Nexus Solutions, our team consists of dedicated professionals who are passionate 
              about delivering exceptional healthcare revenue cycle management services. Our 
              experienced team members bring together expertise in medical billing, coding, 
              compliance, and healthcare administration to provide comprehensive solutions 
              tailored to your needs.
            </p>
          </div>
        </div>
      </section>

      {/* Team Members Grid */}
      <section className="team-members">
        <div className="container">
          <div className="team-grid">
            {teamMembers.map((member) => (
              <TeamMemberCard key={member.id} member={member} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;

